import React, { useEffect, useRef } from 'react';
import { BsStar, BsStarFill } from "react-icons/bs";
import { BsStarHalf } from "react-icons/bs";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

// Intrinsic pixel dimensions for the testimonial author photos, used to
// reserve layout space (CLS) alongside loading="lazy").
const authorImgDimensions = {
    "/images/testimonial/testimonial11.jpg": { width: 800, height: 800 },
    "/images/testimonial/testimonial13.jpg": { width: 612, height: 408 },
    "/images/testimonial/testimonial14.jpg": { width: 579, height: 612 },
    "/images/testimonial/testimonial15.jpg": { width: 800, height: 800 },
    "/images/testimonial/testimonial16.jpg": { width: 1084, height: 1624 },
};

const TestimonialItem = ({ colSize, itemShow, testimonialData, layoutStyle }) => {

    const sliderRef = useRef(null);

    useEffect(() => {
        // Force immediate center positioning on mount
        if (sliderRef.current) {
            setTimeout(() => {
                sliderRef.current.slickGoTo(1, true); // Jump to second slide
                setTimeout(() => {
                    sliderRef.current.slickGoTo(0, true); // Then back to first
                }, 10);
            }, 10);
        }
    }, []);

    useEffect(() => {
        // react-slick clones slides in the DOM to power the infinite loop.
        // Hide those clones from assistive tech and crawlers so the same
        // testimonial text isn't read as duplicated content.
        const markClones = () => {
            document.querySelectorAll('.testimonial-slider-container .slick-cloned').forEach((el) => {
                el.setAttribute('aria-hidden', 'true');
                el.querySelectorAll('a, button').forEach((focusable) => {
                    focusable.setAttribute('tabIndex', '-1');
                });
            });
        };
        markClones();
        const interval = setInterval(markClones, 1000);
        return () => clearInterval(interval);
    }, []);
    
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        cssEase: 'linear',
        initialSlide: 0,
        beforeChange: (current, next) => {
            // Force immediate transform when slide becomes center
            const slides = document.querySelectorAll('.testimonial-slide');
            slides.forEach((slide, index) => {
                if (index === next) {
                    slide.style.transform = 'scale(1.1)';
                    slide.style.opacity = '1';
                } else {
                    slide.style.transform = 'scale(0.9)';
                    slide.style.opacity = '0.7';
                }
            });
        },
        className: "center-slider",
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '0px',
                }
            }
        ]
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;

        // Add full stars
        for (let i = 0; i < fullStars; i++) {
            stars.push(<BsStarFill key={`full-${i}`} color='#ffa700' />);
        }

        // Add half star if needed
        if (hasHalfStar) {
            stars.push(<BsStarHalf key="half" color='#ffa700' />);
        }

        // Add empty stars to make it 5 stars total
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<BsStar key={`empty-${i}`} color='#ffa700' />);
        }

        return stars;
    };
    return (
        <>
            {/* {testimonialData.slice(0, itemShow).map((data, index) => (
                <div className={`${colSize}`} key={index}>
                    <div className={`testimonial-grid ${layoutStyle ? layoutStyle : ""}`}>
                        <span className="social-media">{data.fromtext}</span>
                        <div className="author-info mb-5">
                            <div className="thumb">
                                <img src={process.env.PUBLIC_URL + data.authorimg} alt={data.authorname} />
                            </div>
                            <div className="content">
                                <span className="name">{data.authorname}</span>
                                <span className="designation">{data.authordesig}</span>
                                <span><BsStarFill color='#ffa700'/>
                                <BsStarFill color='#ffa700'/>
                                <BsStarFill color='#ffa700'/> 
                                <BsStarFill color='#ffa700'/>
                                <BsStarHalf color='#ffa700'/>
                                </span>
                                   {renderStars(data.rating)}
                            </div>
                        </div>
                        <p className='mb-0'>{data.description}</p>
                    </div>
                </div>
            ))} */}
            <div className="testimonial-slider-container">
                <Slider {...settings}>
                    {testimonialData.slice(0, itemShow).map((data, index) => (
                        <div
                        style={{
                            transition: 'transform 0.3s ease, opacity 0.3s ease',
                            transform: index === 0 ? 'scale(1.1)' : 'scale(0.9)',
                            opacity: index === 0 ? 1 : 0.7
                        }}
                         className="testimonial-slide" key={index}>
                            <div className="testimonial-card">
                                <div className="author-info">
                                    <div className="author-img-container">
                                        <img
                                            src={process.env.PUBLIC_URL + data.authorimg}
                                            alt={data.authorname}
                                            className="author-img"
                                            loading="lazy"
                                            width={authorImgDimensions[data.authorimg] ? authorImgDimensions[data.authorimg].width : undefined}
                                            height={authorImgDimensions[data.authorimg] ? authorImgDimensions[data.authorimg].height : undefined}
                                        />
                                    </div>
                                    <div className="testimonial-content">
                                        <p className="testimonial-text">{data.description}</p>
                                        <div className="author-details">
                                            <h3 className="author-name">{data.authorname}</h3>
                                            <p className="author-title">{data.authordesig}</p>
                                            
                                            <div className="rating">
                                                {renderStars(data.rating)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </>
    )
}

export default TestimonialItem;